<template>
  <mini-card :value="totalPaid" :subtitle="'Paid'">
    <div slot="header" class="icon-warning">
      <i class="fad fa-file-check text-success"></i>
    </div>
    <template slot="footer">
      <div class="row small ml-0">
        <span><i class="far fa-clock mr-2"/>Last paid: &nbsp;<i>{{ lastPaid }}</i></span>
      </div>
    </template>
  </mini-card>
</template>

<script>
import MiniCard from './MiniCard.vue'
import utils from '../../utils'
export default {
  name: 'Invoices-Paid-MiniCard',
  components: {
    MiniCard
  },
  methods: {},
  computed: {
    lastPaid () {
      const invoices = this.$store.getters.invoices
      let date = new Date(0)
      if (invoices && invoices.length > 0) {
        invoices.forEach(i => {
          if (i.status == 'paid' && !i.archived && i.datePaid
                                                && i.datePaid.getTime() > date.getTime()) {
            date = i.datePaid
                                                }
        })
        if (date.getTime() > 0) {
          return utils.dateToString(date)
        }
        else {
          return '-'
        }
      }
    },
    totalPaid () {
      let total = 0
      this.$store.getters.invoices.forEach(i => i.status == 'paid' ? total += Math.round(100*utils.calcTotal(i)) : null)
      return utils.displayAmount(total/100)
    }
  }
}
</script>

<style>

</style>